import React from 'react';

import ProductSwitcher from '../../utils/ProductSwitcher';
import { colorForBackgroundColor } from '../../utils/RGBColorToHex';

/**
 * Branded header strip shown on the login page when the user arrives
 * via a claim or team-join link. Displays the tag/team logo and name
 * on a colored background that matches the template branding.
 *
 * For claims: prefers signupImage from the template actionText; label from
 * actionText.heading or product type. Never uses tag displayName.
 * For teams: uses the team topLogo and teamName.
 *
 * Renders nothing when there is no context or no image.
 */
export default function LoginContextBanner({ loginContext, locStrings }) {
  if (!loginContext || loginContext.loading || loginContext.type === 'default') return null;

  const isClaim = loginContext.type === 'claim';
  const logo = isClaim
    ? (loginContext.signupImage || loginContext.topLogo || loginContext.avatar)
    : (loginContext.topLogo || loginContext.avatar);
  if (!logo) return null;

  const bgColor = loginContext.rgbColor || '#ff0098';
  const textColor = colorForBackgroundColor(bgColor);
  const label = isClaim
    ? (loginContext.actionTextHeading
        || (locStrings && new ProductSwitcher({ locStrings }).getProductMap(loginContext.product)?.heading))
    : loginContext.teamName;

  return (
    <div
      style={{
        backgroundColor: bgColor,
        width: '100%',
        padding: '24px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <img
        src={logo}
        alt=""
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain',
          borderRadius: '12px',
        }}
      />
      {label && (
        <span style={{ color: textColor, fontSize: '1.1rem', fontWeight: 600 }}>
          {label}
        </span>
      )}
    </div>
  );
}
